import React from 'react';

const SvgCheckCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 71}
      height={props.height || 70}
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.5 70C54.83 70 70.5 54.33 70.5 35C70.5 15.67 54.83 0 35.5 0C16.17 0 0.5 15.67 0.5 35C0.5 54.33 16.17 70 35.5 70ZM14.2785 35.6207L28.7816 50.1238C29.653 50.9953 31.0657 50.9953 31.9371 50.1239L57.5965 24.4644C58.4678 23.593 58.4678 22.1803 57.5965 21.309L54.4411 18.1535C53.5698 17.2822 52.157 17.2822 51.2856 18.1535L30.3594 39.0797L20.5894 29.3098C19.718 28.4383 18.3052 28.4383 17.4339 29.3098L14.2785 32.4652C13.4072 33.3366 13.4072 34.7494 14.2785 35.6207Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgCheckCircle;
